<app-loader *ngIf="loader"></app-loader>
<section>
  <nav class="navbar navbar-expand-lg navbar-light transparent mt-2">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <a routerLink="/bot-info">
        <img src="../../../assets/img/redback.png" alt="back" /><span
          class="title_get"
          class="title_get ml-2"
          >Back</span
        ></a
      >
      <span class="font-weight-bold text-dark">Bot Utility</span>
      <a class="title_get" style="cursor: pointer" (click)="UtilityEdit()"
        >EDIT</a
      >
    </div>
  </nav>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-12">
        <p class="font-weight-bold">Utility details</p>
        <div class="row">
          <div class="col-md-6">Utility name</div>
          <div class="col-md-6 d-flex justify-content-end">
            <p class="text__details" *ngIf="utility">
              {{ utility.utility.utilityName }}
            </p>
            <p class="text__details" *ngIf="!utility">---</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">Consumer ID</div>
          <div class="col-md-6 d-flex justify-content-end">
            <p class="text__details" *ngIf="utility">
              {{ utility.utility.consumerId }}
            </p>
            <p class="text__details" *ngIf="!utility">---</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
